import React, { useState } from "react";
import BestList from "./BestList";

const FlightList = () => {
  const [activeTab, setActiveTab] = useState("Best");

  return (
    <div className="nav-tabs-box mt-0">
      <nav>
        <div className="nav nav-tabs" role="tablist">
          <button className={`nav-link ${activeTab === "Best" ? "active" : ""}`} onClick={() => setActiveTab("Best")} type="button" role="tab" >
            Best
          </button>
          <button className={`nav-link ${activeTab === "Cheapest" ? "active" : ""}`} onClick={() => setActiveTab("Cheapest")} type="button" role="tab">
            Cheapest
          </button>
          <button className={`nav-link ${activeTab === "Fastest" ? "active" : ""}`} onClick={() => setActiveTab("Fastest")} type="button" role="tab">
            Fastest
          </button>
        </div>
      </nav>

      <div className="tab-content">
        {activeTab === "Best" && (
          <div className="tab-pane fade show active">
            <BestList />
          </div>
        )}
        {activeTab === "Cheapest" && (
          <div className="tab-pane fade show active">Cheapest</div>
        )}
        {activeTab === "Fastest" && (
          <div className="tab-pane fade show active">Fastest</div>
        )}
      </div>
    </div>
  );
};

export default FlightList;
